import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h2 className="text-2xl font-bold text-white font-serif mb-6" data-id="element-11">
      Política de Privacidad
    </h2>
    <p className="text-sm text-offwhite/50 mb-6" data-id="element-12">
      Última actualización: Abril 2026
    </p>

    <div className="space-y-6 text-offwhite/80 leading-relaxed" data-id="element-13">
      <section data-id="element-14">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-15">
          1. Información que recopilamos
        </h3>
        <p data-id="element-16">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: dirección de correo electrónico y datos de pago. Los datos de
          pago son procesados directamente por nuestro proveedor de pagos y
          nunca almacenamos números de tarjeta en nuestros servidores.
        </p>
      </section>

      <section data-id="element-17">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-18">
          2. Uso de la información
        </h3>
        <p data-id="element-19">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc list-inside mt-2 space-y-1 text-offwhite/70" data-id="element-20">
          <li data-id="element-21">Procesar y entregar tu compra</li>
          <li data-id="element-22">Enviarte el acceso al producto digital</li>
          <li data-id="element-23">Comunicaciones relacionadas con tu compra</li>
        </ul>
      </section>

      <section data-id="element-24">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-25">
          3. Protección de datos
        </h3>
        <p data-id="element-26">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Utilizamos cifrado SSL para todas
          las transmisiones de datos.
        </p>
      </section>

      <section data-id="element-27">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-28">4. Terceros</h3>
        <p data-id="element-29">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye a terceros de confianza que nos ayudan a
          operar nuestro sitio web o a procesar pagos, siempre que dichas partes
          acuerden mantener esta información confidencial.
        </p>
      </section>

      <section data-id="element-30">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-31">5. Cookies</h3>
        <p data-id="element-32">
          Utilizamos cookies esenciales para el funcionamiento del sitio. No
          utilizamos cookies de seguimiento publicitario.
        </p>
      </section>

      <section data-id="element-33">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-34">6. Tus derechos</h3>
        <p data-id="element-35">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento. Responderemos a tu solicitud en un plazo máximo de 30 días.
        </p>
      </section>
    </div>
  </>;
const termsContent = <>
    <h2 className="text-2xl font-bold text-white font-serif mb-6" data-id="element-36">
      Términos y Condiciones
    </h2>
    <p className="text-sm text-offwhite/50 mb-6" data-id="element-37">
      Última actualización: Abril 2026
    </p>

    <div className="space-y-6 text-offwhite/80 leading-relaxed" data-id="element-38">
      <section data-id="element-39">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-40">
          1. Producto digital
        </h3>
        <p data-id="element-41">
          "Deja de Sobrepensar" es un producto digital (PDF) de acceso
          inmediato. Al completar la compra, recibirás acceso al material
          completo.
        </p>
      </section>

      <section data-id="element-42">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-43">2. Uso personal</h3>
        <p data-id="element-44">
          El contenido adquirido es para uso personal y no puede ser
          redistribuido, revendido, compartido públicamente ni reproducido sin
          autorización expresa por escrito.
        </p>
      </section>

      <section data-id="element-45">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-46">
          3. Política de reembolso
        </h3>
        <p data-id="element-47">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se ofrecen reembolsos una vez completada la descarga. Si experimentas
          problemas técnicos para acceder al producto, te ayudaremos a
          resolverlos.
        </p>
      </section>

      <section data-id="element-48">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-49">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-50">
          Este producto es un recurso educativo e informativo. No sustituye el
          consejo médico, psicológico o psiquiátrico profesional. Si
          experimentas problemas de salud mental graves, consulta a un
          profesional de la salud.
        </p>
      </section>

      <section data-id="element-51">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-52">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-53">
          Todo el contenido, incluyendo textos, gráficos y metodología, está
          protegido por derechos de autor. Queda prohibida su reproducción total
          o parcial sin consentimiento previo.
        </p>
      </section>

      <section data-id="element-54">
        <h3 className="text-lg font-bold text-white mb-2" data-id="element-55">6. Modificaciones</h3>
        <p data-id="element-56">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas inmediatamente después de
          su publicación en esta página.
        </p>
      </section>
    </div>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-900 py-8 border-t border-steel-800" data-id="element-57">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-58">
          <p className="text-sm text-steel-500" data-id="element-59">
            © {new Date().getFullYear()} Deja de Sobrepensar. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-60">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-steel-500 hover:text-amber-500 transition-colors" data-id="element-61">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-steel-500 hover:text-amber-500 transition-colors" data-id="element-62">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-63">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-64">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} onClick={e => e.stopPropagation()} className="bg-navy-800 border border-steel-800 rounded-sm w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-65">
              <div className="flex items-center justify-end p-4 border-b border-steel-800" data-id="element-66">
                <button onClick={() => setActiveModal(null)} className="text-steel-500 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-67">
                  <XIcon className="w-5 h-5" data-id="element-68" />
                </button>
              </div>
              <div className="p-6 sm:p-8 overflow-y-auto max-h-[calc(80vh-60px)]" data-id="element-69">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}